<template>
  <div>
    <div v-if="isLoading">
      <div class="q-pa-md flex flex-center">
        <q-circular-progress
          indeterminate
          size="50px"
          color="primary"
          class="q-ma-md"
        />
      </div>
    </div>
    <div v-else>
      <q-form ref="form">
        <div class="row q-mt-lg q-col-gutter-md">
          <div class="col-12">
            <div
              v-if="(changeImage || !formData.imageUrl) && formData.id"
              style="width: 200px"
            >
              <croppa
                ref="imgCroppa"
                :height="200"
                :width="300"
                v-model="myCroppa"
                remove-button-color="#68c6d2"
                :show-loading="true"
                :loading-size="50"
                crossOrigin="anonymous"
                :quality="2"
                :prevent-white-space="false"
              ></croppa>
              <span class="text-caption"
                >Recommended .jpg/.jpeg files and ideally 500Kb
              </span>
            </div>
            <div v-else style="width: 300px">
              <q-img
                :src="formData.imageUrl"
                style="width: 300px; height: 200px"
                v-if="formData.id"
              >
              </q-img>
              <q-btn
                class="full-width"
                color="primary"
                label="Change"
                @click="changeImage = true"
                v-if="formData.id"
              >
              </q-btn>
              <span class="text-caption"
                >Recommended .jpg/.jpeg files and ideally 500Kb
              </span>
            </div>
          </div>
          <div class="col-3">
            <q-input
              v-model="formData.productService"
              label="Product / Service"
              :rules="[(v) => !!v || 'Field is Required']"
            >
            </q-input>
          </div>
          <div class="col-3">
            <q-input
              v-model="formData.supplierName"
              :rules="[(v) => !!v || 'Field is Required']"
              label="Supplier Name"
            >
            </q-input>
          </div>
          <div class="col-3">
            <q-select
              v-model="formData.serviceArea"
              label="New Zealand Service Area"
              use-input
              @filter="filterRegions"
              :rules="[(v) => !!v || 'Field is Required']"
              :options="filteredRegions"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div class="col-3">
            <q-input v-model="formData.url" label="URL"> </q-input>
          </div>
          <div class="col-12">
            <q-input v-model="formData.about" label="About" type="textarea">
            </q-input>
          </div>
          <div class="col-12">
            <q-btn color="primary" @click="save" class="float-right q-mt-sm">
              <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
              <span class="sustainability-font q-mx-sm" style="font-size: 13px">
                Save
              </span>
            </q-btn>
          </div>
        </div>
      </q-form>
      <div>
        <div v-if="!isAddingBenefit">
          <div class="row q-mb-sm items-center">
            <div class="col-9">
              <div class="row items-center q-col-gutter-x-md">
                <div class="title q-my-none q-mx-none">Benefits</div>

                <div>
                  <q-btn color="primary" @click="addBenefit">
                    <q-icon name="mdi-plus-circle"> </q-icon>
                    <span
                      class="sustainability-font q-mx-sm"
                      style="font-size: 13px"
                    >
                      Add
                    </span>
                  </q-btn>
                </div>
              </div>
            </div>
          </div>
          <data-table
            style="height: calc(100vh - 600px)"
            flat
            :data="benefitsData"
            :columns="columns"
            headerBgColor="#162c47"
            headerTextColor="white"
            @rowDoubleClick="onDoubleClick"
          >
            <template slot="body-cell-outcome" slot-scope="data">
              <q-td :props="data.props">
                <div>
                  {{ getOutcome(data.props.row) }}
                </div>
              </q-td>
            </template>
            <template slot="body-cell-actions" slot-scope="data">
              <q-td :props="data.props">
                <q-btn
                  round
                  color="red"
                  flat
                  icon="mdi-delete"
                  @click="removeBenefit(data.props.row)"
                  size="md"
                  class="float-right"
                >
                  <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                    Remove Benefit
                  </q-tooltip>
                </q-btn>
              </q-td>
            </template>
          </data-table>
        </div>
        <div v-else>
          <div class="row q-mb-sm items-center">
            <div class="col-9">
              <div class="row items-center q-col-gutter-x-md">
                <div>
                  <q-btn flat @click="backFromBenefitForm">
                    <q-icon name="mdi-arrow-left"> </q-icon>
                  </q-btn>
                </div>
                <div class="title q-my-none q-mx-none">Benefit</div>
              </div>
            </div>
          </div>
          <div>
            <find-entry-benefit-form
              @closeForm="backFromBenefitForm"
            ></find-entry-benefit-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/datatable/datatable.vue";
import findEntryBenefitForm from "@/components/solutions/featuredListingTab/findEntryBenefitForm/findEntryBenefitForm.vue";
export default {
  components: {
    DataTable,
    findEntryBenefitForm,
  },
  computed: {
    ...mapGetters({
      data: "solutions/findEntries/featuredListings/selectedFeaturedListing",
      isLoading: "solutions/findEntries/featuredListings/listLoading",
      benefitsData: "solutions/findEntries/featuredEntriesBenefits/list",
    }),
    columns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 60px;max-width: 60px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "outcome",
          label: "Outcome",
          align: "left",
          sortable: true,
        },
        {
          name: "createdAt",
          label: "Created At",
          field: "created_at",
          align: "left",
          format: (val) => {
            return this.$options.filters.gridDateFormat(val);
          },
          style:
            "min-width:30px;max-width:30px;width:30px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "right",
          style:
            "min-width:80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
      ];
    },
  },
  mounted() {
    this.init();
  },
  data: () => ({
    formData: {},
    filteredRegions: [],
    regions: [
      "Nationwide",
      "Auckland",
      "Bay Of Plenty",
      "Canterbury",
      "Gisborne",
      "Hawke's Bay",
      "Manawatu/Whanganui",
      "Marlborough",
      "Nelson/Tasman",
      "Northland",
      "Otago",
      "Southland",
      "Taranaki",
      "Waikato",
      "Wellington",
      "West Coast",
      "North Island",
      "South Island",
    ],
    changeImage: false,
    myCroppa: {},

    //adding benefit
    isAddingBenefit: false,
  }),
  methods: {
    init() {
      this.$store
        .dispatch(
          "solutions/findEntries/featuredListings/loadByID",
          this.$route.params.featuredFindEntry_id
        )
        .then(() => {
          this.formData = JSON.parse(JSON.stringify(this.data));
        });
      this.$store.dispatch(
        "solutions/findEntries/featuredEntriesBenefits/loadAllByFindEntryID",
        this.$route.params.featuredFindEntry_id
      );
    },
    filterRegions(val, update) {
      update(() => {
        if (val === "") {
          this.filteredRegions = this.regions;
        } else {
          const input = val.toLowerCase();
          this.filteredRegions = this.regions.filter(
            (e) => e.toLowerCase().indexOf(input) > -1
          );
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    },
    getOutcome(row) {
      if (row.outcomes_id) {
        return row.name;
      } else {
        return row.customOutcomeTitle;
      }
    },
    backFromBenefitForm() {
      this.$store.commit(
        "solutions/findEntries/featuredEntriesBenefits/setSelectedBenefit",
        null
      );
      this.isAddingBenefit = false;
    },
    onDoubleClick(row) {
      this.$store.commit(
        "solutions/findEntries/featuredEntriesBenefits/setSelectedBenefit",
        row
      );
      this.isAddingBenefit = true;
    },
    removeBenefit(row) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = { ...row };
          payload["deleted_at"] = 1;

          this.$store
            .dispatch(
              "solutions/findEntries/featuredEntriesBenefits/save",
              payload
            )
            .then((result) => {
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "The Action has been removed.",
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        }
      });
    },
    addBenefit() {
      this.isAddingBenefit = true;
    },
    async save() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        let payload = { ...this.formData };
        if (
          payload.findEntryDefault == "" ||
          payload.findEntryDefault == null
        ) {
          payload.findEntryDefault = payload.title;
        }

        //image uploading
        if (this.myCroppa && this.myCroppa.imageSet) {
          payload.imageUrl = {
            dataUrl: this.myCroppa.generateDataUrl(),
          };
        } else {
          delete payload.imageUrl;
        }

        let result = await this.$store.dispatch(
          "solutions/findEntries/featuredListings/save",
          {
            ...payload,
            solutions_id: this.$route.params.id,
            status: "live",
          }
        );
        this.closeForm();
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 13px;
}
</style>
